/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateComponentClassRequestDto } from './CreateComponentClassRequestDto';
import {
    CreateComponentClassRequestDtoFromJSON,
    CreateComponentClassRequestDtoFromJSONTyped,
    CreateComponentClassRequestDtoToJSON,
    CreateComponentClassRequestDtoToJSONTyped,
} from './CreateComponentClassRequestDto';

/**
 * 
 * @export
 * @interface BatchImportComponentClassesRequestDto
 */
export interface BatchImportComponentClassesRequestDto {
    /**
     * Array of component classes to import
     * @type {Array<CreateComponentClassRequestDto>}
     * @memberof BatchImportComponentClassesRequestDto
     */
    items: Array<CreateComponentClassRequestDto>;
}

/**
 * Check if a given object implements the BatchImportComponentClassesRequestDto interface.
 */
export function instanceOfBatchImportComponentClassesRequestDto(value: object): value is BatchImportComponentClassesRequestDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BatchImportComponentClassesRequestDtoFromJSON(json: any): BatchImportComponentClassesRequestDto {
    return BatchImportComponentClassesRequestDtoFromJSONTyped(json, false);
}

export function BatchImportComponentClassesRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchImportComponentClassesRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CreateComponentClassRequestDtoFromJSON)),
    };
}

export function BatchImportComponentClassesRequestDtoToJSON(json: any): BatchImportComponentClassesRequestDto {
    return BatchImportComponentClassesRequestDtoToJSONTyped(json, false);
}

export function BatchImportComponentClassesRequestDtoToJSONTyped(value?: BatchImportComponentClassesRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(CreateComponentClassRequestDtoToJSON)),
    };
}

